export const EMAIL_SUPPORT_CL = "contactophronesis@walmart.com"
